module.exports = __webpack_public_path__ + "img/28-small.83980013.png";